import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { TABLE_FOOT } from '../../utils/TableSectionContext';
export var useTableFoot = function useTableFoot() {
  var _useState = useState({
    data: {
      section: TABLE_FOOT
    }
  }),
      _useState2 = _slicedToArray(_useState, 1),
      tableSectionContextValue = _useState2[0];

  return {
    tableSectionContextValue: tableSectionContextValue
  };
};